<template>
	<Icon v-bind="$props">
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fal"
			data-icon="user-slash"
			class="svg-inline--fa fa-user-slash"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 640 512"
		>
			<path
				class="light"
				d="M320 32c52.94 0 96 43.06 96 96c0 35.88-20.03 66.86-49.27 83.33l26.81 21.17c32.85-23.17 54.45-61.25 54.45-104.5C447.1 57.31 390.7 0 319.1 0C266.1 0 220.1 33.47 201.3 80.71l26.8 21.16C239.5 61.68 276.2 32 320 32zM130.7 480C129.2 480 128 478.8 128 477.3C128 399.4 191.4 336 269.3 336h48.71l-40.53-32H269.3c-95.73 0-173.3 77.6-173.3 173.3c0 19.14 15.52 34.67 34.66 34.67h378.7c8.227 0 15.47-3.275 21.42-8.066L500.4 480H130.7zM633.9 483.4l-608-480c-6.938-5.453-17-4.25-22.48 2.641c-5.469 6.938-4.281 17 2.641 22.48l608 480C617 510.9 620.5 512 623.1 512c4.734 0 9.422-2.094 12.58-6.078C642 498.1 640.8 488.9 633.9 483.4z"
			/>
			<path
				class="regular"
				d="M630.8 469.1l-277.1-217.9c54.69-14.56 95.18-63.95 95.18-123.2C447.1 57.31 390.7 0 319.1 0C250.2 0 193.7 55.93 192.3 125.4l-153.4-120.3C34.41 1.672 29.19 0 24.03 0C16.91 0 9.845 3.156 5.127 9.187C-3.061 19.62-1.248 34.72 9.189 42.89L601.2 506.9c10.5 8.203 25.56 6.328 33.69-4.078C643.1 492.4 641.2 477.3 630.8 469.1zM290.1 202.1L255.6 175C245.9 161.8 240 145.6 240 128c0-44.11 35.89-80 80-80s80 35.89 80 80c0 44.11-35.89 80-80 80C309.4 208 299.4 205.8 290.1 202.1zM144.1 464C152.9 400.9 206.8 352 272 352h53.75L264.9 304.3C170.1 307.1 96 385.2 96 480c0 17.67 14.33 32 32 32h384c4.938 0 9.477-1.324 13.65-3.322L468.6 464H144.1z"
			/>
			<path
				class="solid"
				d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L353.3 251.6C407.9 237 448 187.2 448 128C448 57.3 390.7 0 320 0C250.2 0 193.5 55.8 192 125.2L38.8 5.1zM264.3 304.3C170.5 309.4 96 387.2 96 482.3c0 16.4 13.3 29.7 29.7 29.7H514.3c3.9 0 7.6-.7 11-2.1l-261-205.6z"
			/>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'UserSlashIcon',
	components: { Icon },
	props,
}
</script>
